import { Invoice } from '@/invoice';
import { ref } from 'vue';
import { usePayee } from '@/payee.composable';
import { API } from 'aws-amplify';

const invoices = ref<Invoice[]>([]);

export function useInvoice() {
  return {
    invoices,
    getInvoice,
    findInvoices,
  }
}

async function getInvoice(invoiceId: string[] | string) {
  const fetchedInvoice = invoices.value.find(invoice => invoice.id === invoiceId);
  if (fetchedInvoice) {
    return fetchedInvoice;
  } else {
    const { payee } = usePayee();
    return API.get('API', `/v1/payees/${payee.value?.id}/invoices/${invoiceId}`, {});
  }
}

async function findInvoices(firstName: string, lastName: string, total: number) {
  const query = `firstname=${firstName}&lastname=${lastName}&total=${total}`;
  const { payee } = usePayee();
  if (!payee.value) {
    throw new Error('Payee not loaded');
  }
  const result = await API.get('API', `/v1/payees/${payee.value.id}/invoices?${query}`, {});
  invoices.value = result;
  return result;
}
